import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import { TabsHorizontal, TabHorizontal } from '../../../core/TabsHorizontal';
import { AccordionTable } from '../../../core/AccordionTable';
import Button from '../../../core/Buttons';
import { TwoLevelBreadcrumb } from '../../../views/Employee/FiscalData';

const StyledContainer = styled.div`
  background: white;
`;

const StyledTabsContainer = styled.div`
  position: relative;
  &:before {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: ${rem('30px')};
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    z-index: 10;
    ${mediaqueries.greaterThan('mobile')`
      content: none;
    `};
  }
  &:after {
    content: '';
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: ${rem('30px')};
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    ${mediaqueries.greaterThan('mobile')`
      content: none;
    `};
  }
`;

const StyledTabsHorizontal = styled(TabsHorizontal)`
  display: block;
  margin-bottom: ${rem('15px')};
  padding-left: ${rem('35px')};
  padding-right: ${rem('30px')};
  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('40px')};
    padding-left: 0;
    padding-right: 0;
  `};
`;

const StyledTabHorizontal = styled(TabHorizontal)``;

const StyledWrapper = styled.div`
  max-width: ${rem('1270px')};
  margin: ${rem('30px')} auto 0;
  ${mediaqueries.greaterThan('mobile')`
    padding: 0 ${rem('20px')} ${rem('40px')};
  `};
`;

const StyledAlignRight = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: ${rem('38px')} 0 ${rem('54px')};
  position: relative;
  z-index: 5;
  ${mediaqueries.greaterThan('mobile')`
    margin-right: ${rem('20px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right: 0;
  `};
`;

const StyledAccordionContainer = styled.div`
  margin: 0 ${rem('20px')};
`;

const StyledAccordionTable = styled(AccordionTable)`
  margin: 0 auto ${rem('20px')};
`;

const StyledMessage = styled.div`
  display: flex;
  margin: 0 auto ${rem('10px')};
  font-weight: bold;
  line-height: 1;
  justify-content: space-between;
  align-items: center;
  min-height: ${rem('38px')};
  padding: ${rem('5px')} ${rem('20px')};
  background-color: ${props => props.theme.colors.pending};
  font-size: ${rem('12px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('14px')};
  `};
`;

const StyledMessageButtons = styled.div`
  display: flex;
  align-items: stretch;
`;
const StyledMessageButton = styled(Button)`
  padding: 0;
  &:nth-child(2) {
    /* Para alinear el segundo botón */
    margin-bottom: ${rem('-3px')};
  }
  > svg {
    margin: 0 ${rem('5px')};
  }
`;

const StyledButtonPlus = styled(Button)`
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  position: absolute;
  bottom: ${rem('34px')};
  right: 0;

  & > svg {
    position: relative;
    left: ${rem('4px')};
  }

  ${mediaqueries.greaterThan('desktop')`
    position: static;
    margin-bottom: 2px;
  `};
`;

const StatusMessageWrapper = styled.div`
  margin: 0 ${rem('20px')} ${rem('30px')};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 ${rem('30px')};
  `};
`;

const ParentContainer = styled.div`
  margin-bottom: ${rem('15px')};
  background-color: ${props => props.theme.colors.grayMoreLight};
  ${mediaqueries.greaterThan('desktop')`
    width: 100%;
    display: flex;
    flex-flow: row wrap;
  `};
`;

const StyledTwoLevelBreadcrumb = styled(TwoLevelBreadcrumb)`
  margin: 0 ${rem('15px')} ${rem('20px')};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 ${rem('20px')};
  `}
`;

export {
  StyledContainer,
  StyledTabsContainer,
  StyledTabsHorizontal,
  StyledTabHorizontal,
  StyledWrapper,
  StyledAlignRight,
  StyledAccordionTable,
  StyledMessage,
  StyledMessageButtons,
  StyledMessageButton,
  StyledAccordionContainer,
  StyledButtonPlus,
  StatusMessageWrapper,
  ParentContainer,
  StyledTwoLevelBreadcrumb
};
